module.exports = __webpack_public_path__ + "static/Q8Answer3_Uptownfunk_thor_alvis-1ed469d3dbd29f8e3d56ef20471c4f95.jpg";